import React from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import MapComponent from "./MapComponent";
import { Helmet } from "react-helmet-async";

function HowToReach() {
  return (
    <div>
      <Helmet>
        <title>How to Reach ISKCON Vijayawada – Location & Directions</title>
        <meta
          name="description"
          content="Find out how to reach ISKCON Vijayawada temple with detailed directions, transport options, and travel tips for a peaceful spiritual visit."
        />
        <meta
          name="keywords"
          content="how to reach ISKCON Vijayawada, ISKCON vijayawada temple location,iskcon vijayawada temple address, ISKCON vijayawad directions"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="How to Reach ISKCON Vijayawada – Location & Directions"
        />
        <meta
          property="og:description"
          content="Find out how to reach ISKCON Vijayawada temple with detailed directions, transport options, and travel tips for a peaceful spiritual visit."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/HowToReach"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="How to Reach ISKCON Vijayawada – Location & Directions"
        />
        <meta
          name="twitter:description"
          content="Find out how to reach ISKCON Vijayawada temple with detailed directions, transport options, and travel tips for a peaceful spiritual visit."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/HowToReach"
        />
      </Helmet>

      <Header />
      <MapComponent />
      <Footer />
    </div>
  );
}

export default HowToReach;
